function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.667 12.533a3.2 3.2 0 013.2-3.2h4.266a3.2 3.2 0 013.2 3.2 2.133 2.133 0 01-2.133 2.134H4.8a2.133 2.133 0 01-2.133-2.134zM10.667 4a2.667 2.667 0 11-5.334 0 2.667 2.667 0 015.334 0z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#666A72"
  }, props), _ref);
};

export default SvgUser;